"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  noFileChosen: {
    "id": "No file chosen",
    "defaultMessage": "No file chosen"
  },
  browse: {
    "id": "Browse",
    "defaultMessage": "Browse"
  },
  dropFilesHereToUpload: {
    "id": "Drop files here to upload",
    "defaultMessage": "Drop files here to upload"
  },
  fileSize: {
    "id": "sb-file-input.fileSize",
    "defaultMessage": "File size"
  }
});
exports.messages = messages;
//# sourceMappingURL=sb-file-input-i18n.js.map